<template>
  <div id="marketplace-container">
    <div>
      <div id="title-container">
        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="50" height="50" rx="7.86517" fill="#F7F7F7"/>
          <path d="M15.7051 22.8613V32.4767C15.7051 33.0434 15.9302 33.5869 16.3309 33.9876C16.7316 34.3883 17.2751 34.6135 17.8418 34.6135H32.7991C33.3658 34.6135 33.9093 34.3883 34.31 33.9876C34.7107 33.5869 34.9358 33.0434 34.9358 32.4767V22.8613" stroke="#7C7C7C" stroke-width="1.60256"/>
          <path d="M28.5255 34.8302V28.42C28.5255 27.8533 28.3004 27.3098 27.8997 26.909C27.4989 26.5083 26.9554 26.2832 26.3887 26.2832H24.252C23.6853 26.2832 23.1418 26.5083 22.7411 26.909C22.3404 27.3098 22.1152 27.8533 22.1152 28.42V34.8302" stroke="#F6A620" stroke-width="1.60256" stroke-miterlimit="16"/>
          <path d="M35.8057 22.1839L33.9958 15.8495C33.9575 15.7156 33.8766 15.5978 33.7654 15.5139C33.6542 15.4301 33.5187 15.3847 33.3794 15.3848H29.0557L29.5631 21.4788C29.571 21.5767 29.602 21.6714 29.6537 21.755C29.7053 21.8386 29.7761 21.9087 29.8602 21.9596C30.2768 22.2085 31.0909 22.6679 31.7266 22.8634C32.8121 23.1978 34.3975 23.0771 35.3014 22.966C35.3893 22.9546 35.4736 22.9242 35.5485 22.8769C35.6234 22.8296 35.6871 22.7665 35.7351 22.692C35.7831 22.6176 35.8143 22.5335 35.8265 22.4458C35.8387 22.358 35.8316 22.2686 35.8057 22.1839Z" stroke="#7C7C7C" stroke-width="1.60256"/>
          <path d="M27.453 22.8634C28.0598 22.6764 28.8291 22.2501 29.2585 21.9959C29.3585 21.9361 29.4396 21.8494 29.4925 21.7456C29.5454 21.6419 29.568 21.5253 29.5577 21.4093L29.0555 15.3848H21.5769L21.0748 21.4093C21.0643 21.5255 21.0868 21.6423 21.1397 21.7462C21.1926 21.8502 21.2738 21.9371 21.3739 21.9969C21.8034 22.2502 22.5726 22.6764 23.1795 22.8634C24.7746 23.3549 25.8579 23.3549 27.453 22.8634Z" stroke="#7C7C7C" stroke-width="1.60256"/>
          <path d="M16.6395 15.8495L14.8297 22.185C14.8042 22.2696 14.7973 22.3587 14.8097 22.4462C14.8221 22.5337 14.8533 22.6175 14.9013 22.6917C14.9493 22.7659 15.0128 22.8288 15.0876 22.8759C15.1623 22.9231 15.2464 22.9535 15.334 22.9649C16.2368 23.0771 17.8233 23.1967 18.9088 22.8634C19.5445 22.6679 20.3596 22.2085 20.7752 21.9606C20.8594 21.9097 20.9303 21.8394 20.982 21.7556C21.0336 21.6718 21.0646 21.5769 21.0722 21.4788L21.5797 15.3848H17.256C17.1167 15.3847 16.9812 15.4301 16.87 15.5139C16.7587 15.5978 16.6778 15.7156 16.6395 15.8495Z" stroke="#7C7C7C" stroke-width="1.60256"/>
        </svg>
        <h2>Marketplace</h2>
        <small>Shop for application / activites.</small>
      </div>
      <div id="search-filter-container">
        <input type="text" placeholder="Search for an Application" />
        <select>
          <option value="" disabled selected>Sort By</option>
        </select>
        <select>
          <option value="" disabled selected>Age Range</option>
        </select>
        <select>
          <option value="" disabled selected>Area</option>
        </select>
        <select>
          <option value="" disabled selected>Pricing</option>
        </select>
      </div>
      <div id="marketplace-app-format">
        <article v-for="(app, index) in applicationList" class="application-container" :key="index">
          <router-link :to="`/application/${app.application_id}`">
            <div class="grid-container">
              <img v-if="app.image" :src="`${reverseProxy}/api/${app.image}`" alt="Picture N/A" loading="lazy"/>
              <div>
                <h5>{{ app.title }}</h5>
                <div v-if="app.is_free">
                  Free
                </div>
                <div v-else>
                  <div class="unit-pricing">{{  `${getCurrencySymbol(app.currency_code)}${app.single_unit_pricing}` }}</div>
                  <div class="monthly-pricing">{{ `or ${getCurrencySymbol(app.currency_code)}${app.monthly_subscription_pricing}/month` }}</div>
                </div>
              </div>
            </div>
          </router-link>
        </article>
      </div>
    </div>
  </div>
</template>

<script> 
  import instance from '../axios.js'; 

  export default {
    data() {
      return {
        reverseProxy: process.env.VUE_APP_REVERSE_PROXY_ENDPOINT,
        applicationList: null,
        categorization: null,
        maxAgeRange: 100,
        pricingModalObject: null,
        inputObject: {
          search_query: '',
          startAgeValue: 'All',
          endAgeValue: 'All',
          classification: 'All',
          area: 'All',
          type: 'All',
          category: 'All',
          sub_category: 'All',
          periodStart: '',
          periodEnd: ''
        },
      }
    },
    async created() {
      try {
        this.assignFilteringValues();
        let response = await instance.get('/api/appAdmin/searchfilter', {
          params: {
            ...this.params,
            published: true
          }
        });
        this.applicationList = response.data;
      } catch (e) {
        console.error(e);
      }
    },
    methods: {
      openModal(id) {
        document.getElementById(id).showModal();
      },
      closeModal(id) {
        document.getElementById(id).close();
      },
      assignFilteringValues() {
        this.params = this.getQueryParams();
        //parse query so search/filter can be used again with auto filled current data
        for (let key in this.params) {
          if (Object.hasOwnProperty.call(this.inputObject, key)) {
            this.inputObject[key] = this.params[key];
          }
          else if (key == 'age_group') {
            let ages = this.params['age_group'].split(',');
            this.inputObject.startAgeValue = ages[0];
            this.inputObject.endAgeValue = ages[1];
          }
          else if (key == 'created') {
            let dates = this.params['created'].split(',');
            this.inputObject.periodStart = dates[0] == 'All' ? '' : dates[0];
            this.inputObject.periodEnd = dates[1] == 'All' ? '' : dates[1];
          }
        }
      },
      changeStartDate() {
        let from = document.getElementById('startDate');
        let to = document.getElementById('endDate');
        if (from.value >= to.value && to.value !== '') {
          let temp = new Date(from.value);
          temp.setDate(temp.getDate());
          to.valueAsDate = temp;
        }
        to.min = from.value;
      },
      changeStartAgeRange() {
        let from = document.getElementById('startAge');
        let to = document.getElementById('endAge');
        if (from.value != 'All' && to.value != 'All') {
          if (parseInt(from.value) > parseInt(to.value)) {
            this.inputObject.endAgeValue = this.maxAgeRange;
          }
        }
      },
      getQueryParams() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const params = {};
        for (const [key, value] of urlParams.entries()) {
          params[key] = value;
        }
        return params;
      },
      async newFilters() {
        try {
          let ageRangeResult = '';
          ageRangeResult += this.inputObject.startAgeValue;
          ageRangeResult += ',';
          ageRangeResult += this.inputObject.endAgeValue;

          let periodRangeResult = '';
          periodRangeResult += this.inputObject.periodStart == '' ? 'All' : this.inputObject.periodStart;
          periodRangeResult += ',';
          periodRangeResult += this.inputObject.periodEnd == '' ? 'All' : this.inputObject.periodEnd;

          const currentRoute = this.$route;
          const targetQuery = {
            ...(this.inputObject.search_query == '' ? {} : {search_query: this.inputObject.search_query}),
            ...(ageRangeResult == 'All,All' ? {} : {age_group: ageRangeResult}),
            ...(this.inputObject.classification == 'All' ? {} : {classification: this.inputObject.classification}),
            ...(this.inputObject.area == 'All' ? {} : {area: this.inputObject.area}),
            ...(this.inputObject.type == 'All' ? {} : {type: this.inputObject.type}),
            ...(this.inputObject.category == 'All' ? {} : {category: this.inputObject.category}),
            ...(this.inputObject.sub_category == 'All' ? {} : {sub_category: this.inputObject.sub_category}),
            ...(periodRangeResult == 'All,All' ? {} : {created: periodRangeResult})
          };
          const currentKeys = Object.keys(currentRoute.query);
          const targetKeys = Object.keys(targetQuery);
          const isSameKeys = currentKeys.length === targetKeys.length && currentKeys.every(key => targetKeys.includes(key));
          const isDifferentQuery = !isSameKeys || !currentKeys.every(key =>
            currentRoute.query[key] === targetQuery[key]
          );

          if (isDifferentQuery) {
            this.$router.replace({ query: targetQuery });
            this.assignFilteringValues();
            let response = await instance.get('/api/appAdmin/searchfilter', {
              params: {
                ...this.params,
                published: true
              }
            });
            this.applicationList = response.data;
          }

        } catch (e) {
          console.error(e);
        }
      },
      getCurrencySymbol(currencyCode) {
        const currencyMap = {
            USD: "$",
            EUR: "€",
            GBP: "£",
            JPY: "¥",
            CNY: "¥",
            RUB: "₽"
        };
        return currencyMap[currencyCode] || "";
      },
    }
  }
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';

  #marketplace-container {
    position: relative;

    > div {
      padding: 1rem;
    }

    a {
      color: globalSharedVariables.$grey-900;
    }
  }

  #title-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h2 {
      margin: 0;
    }

    small {
      color: #5A5A5A;
      font-size: 1rem;
    }
  }

  #search-filter-container {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;

    input[type="text"] {
      width: 330px;
    }

    > * {
      margin: 5px;
    }
  }

  #marketplace-app-format {
    display: flex;
    column-gap: 5px;
    row-gap: 2rem;
    flex-wrap: wrap;

    h5 {
      margin: 0;
      font-weight: 400;
    }

    .application-container {
      $card-height: 140px;
      $card-image-width: 200px;
      $card-grid-gap: 5px;
      $card-info-width: 380px;

      img {
        width: $card-image-width;
        height: $card-height;
        border-radius: 10px;
      }

      .grid-container {
        display: grid;
        grid-template-columns: $card-image-width  $card-info-width;
        column-gap: $card-grid-gap;
      }

      .monthly-pricing {
        color: #636363;
        font-size: .8rem;
      }

      .unit-pricing {
        font-weight: 700;
      }
    }
  }

</style>